import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fd1cec96"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd1cec96')) {
      api.createRecord('fd1cec96', component.options)
    } else {
      api.reload('fd1cec96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fd1cec96", function () {
      api.rerender('fd1cec96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/ordinary/index.vue"
export default component.exports